/**
 * Created by Ning Jiang on 8/21/2018.
 */

import {Background, IBackgroundConfig} from "@nolimitcity/slot-game/bin/core/background/Background";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IceIceYetiGameAssets} from "../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../IceIceYetiGameConfig";
import {TweenLite} from "gsap";

export class IceIceYetiBackground extends Background {

    private _backgroundContainer:PIXI.Container;
    private _foregroundContainer:PIXI.Container;
    private _backgroundSprite_main:PIXI.Sprite;
    private _backgroundSprite_rs:PIXI.Sprite;
    private _topForegroundSprite_main:PIXI.Sprite;
    private _bottomForegroundContainer_main:PIXI.Container
    private _topForegroundSprite_rs:PIXI.Sprite;
    private _bottomForegroundContainer_rs:PIXI.Container;

    private _reelBackgroundSprite:PIXI.Sprite;
    private _reelBackgroundRespinSprite:PIXI.Sprite;

    constructor(config:IBackgroundConfig) {
        super(config);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._backgroundContainer = new PIXI.Container();
        this.addChild(this._backgroundContainer);

        this._backgroundSprite_main = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.MAIN_GAME_BACKGROUND_LANDSCAPE)[0]);
        this._backgroundSprite_main.anchor.set(0.5, 0.5);
        this._backgroundSprite_main.position.set(GameConfig.instance.GAME_WIDTH / 2, GameConfig.instance.GAME_HEIGHT / 2);
        this._backgroundContainer.addChild(this._backgroundSprite_main);

        this._backgroundSprite_rs = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.RESPIN_BACKGROUND_LANDSCAPE)[0]);
        this._backgroundSprite_rs.alpha = 0;
        this._backgroundSprite_rs.anchor.set(0.5, 0.5);
        this._backgroundSprite_rs.position.set(GameConfig.instance.GAME_WIDTH / 2, GameConfig.instance.GAME_HEIGHT / 2);
        this._backgroundContainer.addChild(this._backgroundSprite_rs);

        const foregroundLayer:ScalableLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.FOREGROUND.name);
        this._foregroundContainer = new PIXI.Container();
        foregroundLayer.addChild(this._foregroundContainer);

        this._topForegroundSprite_main = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.MAIN_GAME_TOP_FOREGROUND)[0]);
        this._topForegroundSprite_main.anchor.set(0.5, 0.5);
        this._topForegroundSprite_main.position.set(633, -130);
        this._foregroundContainer.addChild(this._topForegroundSprite_main);

        const leftForeground:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.MAIN_GAME_BOTTOM_FOREGROUND_LEFT)[0]);
        const rightForeground:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.MAIN_GAME_BOTTOM_FOREGROUND_RIGHT)[0]);
        this._bottomForegroundContainer_main = new PIXI.Container();
        this._bottomForegroundContainer_main.addChild(leftForeground);
        this._bottomForegroundContainer_main.addChild(rightForeground);
        rightForeground.position.x = leftForeground.texture.width;
        rightForeground.position.y = 230;
        this._bottomForegroundContainer_main.pivot.set((this._bottomForegroundContainer_main.width * 0.5), (this._bottomForegroundContainer_main.height * 0.5));
        this._bottomForegroundContainer_main.position.set(GameConfig.instance.GAME_WIDTH / 2, 710);
        this._foregroundContainer.addChild(this._bottomForegroundContainer_main);

        this._topForegroundSprite_rs = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.RESPIN_TOP_FOREGROUND)[0]);
        this._topForegroundSprite_rs.alpha = 0;
        this._topForegroundSprite_rs.anchor.set(0.5, 0.5);
        this._topForegroundSprite_rs.position.set(633, -130);
        this._foregroundContainer.addChild(this._topForegroundSprite_rs);

        const leftForegroundRS:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.RESPIN_BOTTOM_FOREGROUND_LEFT)[0]);
        const rightForegroundRS:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.RESPIN_BOTTOM_FOREGROUND_RIGHT)[0]);
        this._bottomForegroundContainer_rs = new PIXI.Container();
        this._bottomForegroundContainer_rs.addChild(leftForegroundRS);
        this._bottomForegroundContainer_rs.addChild(rightForegroundRS);
        rightForegroundRS.position.x = leftForegroundRS.texture.width;
        rightForegroundRS.position.y = 230;
        this._bottomForegroundContainer_rs.pivot.set((this._bottomForegroundContainer_rs.width * 0.5), (this._bottomForegroundContainer_rs.height * 0.5));
        this._bottomForegroundContainer_rs.position.set(GameConfig.instance.GAME_WIDTH / 2, 710);
        this._foregroundContainer.addChild(this._bottomForegroundContainer_rs);

        const reelBackgroundLayer:ScalableLayer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.REEL_BACKGROUND.name);

        this._reelBackgroundSprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.REEL_BACKGROUND_IMAGE)[0]);
        this._reelBackgroundSprite.anchor.set(0.5, 0.5);
        this._reelBackgroundSprite.position.set(625, 192);
        reelBackgroundLayer.addChild(this._reelBackgroundSprite);

        this._reelBackgroundRespinSprite = new PIXI.Sprite(GameResources.getTextures(IceIceYetiGameAssets.REEL_BACKGROUND_RESPIN_IMAGE)[0]);
        this._reelBackgroundRespinSprite.anchor.set(0.5, 0.5);
        this._reelBackgroundRespinSprite.position.set(625, 192);
        this._reelBackgroundRespinSprite.alpha = 0;
        reelBackgroundLayer.addChild(this._reelBackgroundRespinSprite);
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        if(!super.onChangeBackground(data)) {
            return false;
        }

        if(data.newMode === GameMode.RESPIN) {
            TweenLite.to(this._backgroundSprite_rs, 3, {alpha : 1});
            TweenLite.to(this._bottomForegroundContainer_main, 0.8, {alpha : 0, delay : 2.3});
            TweenLite.to(this._topForegroundSprite_main, 0.8, {alpha : 0, delay : 2.3});
            TweenLite.to(this._bottomForegroundContainer_rs, 3, {alpha : 1});
            TweenLite.to(this._topForegroundSprite_rs, 3, {alpha : 1});
            TweenLite.to(this._reelBackgroundSprite, 0.8, {alpha : 0, delay : 2.3});
            TweenLite.to(this._reelBackgroundRespinSprite, 3, {alpha : 1});
        } else {
            TweenLite.to(this._backgroundSprite_rs, 1, {alpha : 0});
            TweenLite.to(this._bottomForegroundContainer_rs, 1, {
                alpha : 0,
                onStart : () => this._bottomForegroundContainer_main.alpha = 1
            });
            TweenLite.to(this._topForegroundSprite_rs, 1, {
                alpha : 0,
                onStart : () => this._topForegroundSprite_main.alpha = 1
            });
            TweenLite.to(this._reelBackgroundRespinSprite, 1, {
                alpha : 0,
                onStart : () => this._reelBackgroundSprite.alpha = 1
            });
        }

        /*
                if(data.newMode === GameMode.RESPIN) {
            TweenLite.to(this._backgroundSprite_rs, 3, {alpha : 1});
            TweenLite.to(this._foregroundSprite_main, 0.8, {alpha : 0, delay : 2.3});
            TweenLite.to(this._foregroundSprite_rs, 3, {alpha : 1});
            TweenLite.to(this._reelBackgroundSprite, 0.8, {alpha : 0, delay : 2.3});
            TweenLite.to(this._reelBackgroundRespinSprite, 3, {alpha : 1});
        } else {
            TweenLite.to(this._backgroundSprite_rs, 1, {alpha : 0});
            TweenLite.to(this._foregroundSprite_rs, 1, {
                alpha : 0,
                onStart : () => this._foregroundSprite_main.alpha = 1
            });
            TweenLite.to(this._reelBackgroundRespinSprite, 1, {
                alpha : 0,
                onStart : () => this._reelBackgroundSprite.alpha = 1
            });
        }
         */

        return true;
    }

    get foreground():PIXI.Container {
        return this._foregroundContainer;
    }

    get background():PIXI.Container {
        return this._foregroundContainer;
    }

    get reelBackground():PIXI.Sprite {
        return this._reelBackgroundSprite;
    }
}